export default __webpack_public_path__ + "static/media/map-north.e545b835.jpg";